export default __webpack_public_path__ + "static/media/gym.a8c3ff4c.svg";